import React, { useState } from 'react';
import { BookOpen, ChevronRight, ChevronDown, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

const BASE = '/manual';

const SECTIONS = [
  { id: 'login', title: '1. Accesso al Sistema', img: '01_login.jpeg', content: [
    { sub: '1.1 Pagina di Login', text: 'Per accedere al sistema: aprire il browser, inserire Email e Password, cliccare "Accedi".' },
    { sub: '1.2 Primo Accesso', text: 'Al primo utilizzo cliccare "Carica Dati Demo" per popolare con dati di esempio.' },
    { sub: '1.3 Ruoli Utente', text: 'Admin (accesso completo), Qualita (controlli e NC), Produzione (lotti), Operatore (fasi assegnate), Direzione (sola lettura).' },
  ]},
  { id: 'dashboard', title: '2. Cruscotto (Dashboard)', img: '02_dashboard.jpeg', content: [
    { sub: '2.1 Panoramica Produzione', text: 'Schede riepilogative: Ordini Aperti, Lotti in Corso, Lotti in Ritardo, NC Aperte.' },
    { sub: '2.2 Metriche Qualita', text: 'Resa al Primo Passaggio, Qta Buona/Scarti, Costo Totale NC.' },
    { sub: '2.3 Grafici', text: 'Lotti per Stato (barre) e Non Conformita per Tipo (torta).' },
  ]},
  { id: 'clienti', title: '3. Gestione Clienti', img: '03_clienti.jpeg', content: [
    { sub: '3.1 Lista Clienti', text: 'Codice, Nome, Citta, Contatto, Email, Telefono, Stato.' },
    { sub: '3.2 Operazioni', text: '"+ Aggiungi Cliente" per creare. Icona matita per modificare, cestino per eliminare. Barra di ricerca per filtrare.' },
  ]},
  { id: 'prodotti', title: '4. Gestione Prodotti', img: '04_prodotti.jpeg', content: [
    { sub: '4.1 Lista Prodotti', text: 'Codice, Nome, Cliente, Materiale, Famiglia, Stato. Filtri per codice/nome, cliente, stato.' },
  ]},
  { id: 'prodotto-dettaglio', title: '5. Dettaglio Prodotto', img: '05_prodotto_dettaglio.jpeg', content: [
    { sub: 'Tab Info Prodotto', text: 'Codice, Cliente, Famiglia, Unita misura, Materiale, Trattamento esterno.' },
    { sub: 'Tab Revisioni', text: 'Codice revisione, data, descrizione, stato (active/obsolete).' },
    { sub: 'Tab Ciclo di Lavoro', text: 'Fasi di lavorazione: numero, descrizione, centro lavoro, tempo ciclo, tempo setup.' },
    { sub: 'Tab Piani di Controllo', text: 'Piani associati alla revisione attiva.' },
    { sub: 'Tab Allegati', text: 'Upload e gestione file (disegni, documenti).' },
  ]},
  { id: 'utensili', title: '6. Lista Utensili (Inline)', img: '06_utensili.jpeg', content: [
    { sub: 'Campi', text: 'Sequenza, Codice, Descrizione, Fase di Lavoro, Altezza (mm), Raggio (mm), Note.' },
    { sub: 'Aggiungi', text: 'Clicca "+ Aggiungi Utensile" - compare nuova riga editabile.' },
    { sub: 'Modifica', text: 'Hover sulla riga > icona matita. La riga diventa editabile. Salva con segno di spunta.' },
    { sub: 'Elimina', text: 'Hover sulla riga > icona cestino (con conferma).' },
    { sub: 'Stampa', text: 'Pulsante "Stampa" per lista A4.' },
  ]},
  { id: 'ordini', title: '7. Gestione Ordini', img: '07_ordini.jpeg', content: [
    { sub: '7.1 Lista', text: 'N. Ordine, Cliente, Rif. Cliente, Data Ordine/Consegna, Priorita, Stato.' },
    { sub: '7.2 Nuovo Ordine', text: '"+ Nuovo Ordine": compilare cliente, date, priorita. Aggiungere righe con prodotto, revisione, quantita, data consegna.' },
    { sub: '7.3 Stampa', text: 'Dal dettaglio ordine, pulsante "Stampa" per documento A4.' },
  ]},
  { id: 'lotti', title: '8. Lotti di Produzione', img: '08_lotti.jpeg', content: [
    { sub: '8.1 Lista', text: 'Codice Lotto, Prodotto, Cliente, Ordine, Qta, Buoni, Scarti, Apertura, Stato.' },
    { sub: '8.2 Stati', text: 'Open > In Progress > Closed / Suspended.' },
    { sub: '8.3 Dettaglio', text: 'Avanzamento fasi, registrazione pezzi buoni/scarti, lista utensili, allegati, stampa A4.' },
  ]},
  { id: 'controlli', title: '9. Controlli Eseguiti', img: '09_controlli.jpeg', content: [
    { sub: '9.1 Panoramica', text: 'Contatori (Totali, OK, NOK). Tabella con lotto, codice, caratteristica, valore, operatore, strumento, risultato.' },
    { sub: '9.2 Azione NOK', text: 'Per controlli NOK appare pulsante rosso "Azione" per creare Pending Collaudo pre-compilato.' },
  ]},
  { id: 'collaudo', title: '10. Pending Collaudo', img: '10_collaudo.jpeg', content: [
    { sub: '10.1 Dashboard', text: 'Schede: Da Fare (giallo), Eseguite (blu), Verificate (verde). Tab, ricerca, filtro priorita.' },
    { sub: '10.2 Workflow', text: 'DA FARE > ESEGUITA (nota esecuzione obbligatoria) > VERIFICATA (nota verifica obbligatoria).' },
    { sub: '10.3 Nuova Azione', text: '"+ Nuova Azione": lotto, problema, nota KO, azione richiesta, priorita, scadenza, assegnatario.' },
  ]},
  { id: 'nc', title: '11. Non Conformita', img: '11_nc.jpeg', content: [
    { sub: '11.1 Lista', text: 'Numero NC, Tipo (internal/supplier/customer), Data, Prodotto, Lotto, Gravita, Stato, Costo.' },
    { sub: '11.2 Dettaglio', text: 'Informazioni, causa, azioni correttive, costi, allegati.' },
  ]},
  { id: 'utenti', title: '12. Gestione Utenti', img: '12_utenti.jpeg', content: [
    { sub: '12.1 Tabella', text: 'Nome, Email Login, Email Reale, Ruolo, Reparto, Stato.' },
    { sub: '12.2 Nuovo Utente', text: '"+ Nuovo Utente": Nome, Cognome, Email Login, Password, Email Reale, Ruolo, Reparto.' },
    { sub: '12.3 Modifica/Disattiva', text: 'Icona matita per modificare, cestino per disattivare.' },
  ]},
];

function Section({ section }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden mb-4 bg-white" data-testid={`manual-section-${section.id}`}>
      <button
        className="w-full flex items-center justify-between p-4 hover:bg-slate-50 transition-colors text-left"
        onClick={() => setOpen(!open)}
      >
        <span className="font-semibold text-slate-900 text-base">{section.title}</span>
        {open ? <ChevronDown className="w-5 h-5 text-slate-400" /> : <ChevronRight className="w-5 h-5 text-slate-400" />}
      </button>
      {open && (
        <div className="border-t border-slate-100">
          <div className="p-4">
            <img
              src={`${BASE}/${section.img}`}
              alt={section.title}
              className="w-full rounded-lg border border-slate-200 shadow-sm mb-4"
              loading="lazy"
            />
            <div className="space-y-3">
              {section.content.map((item, i) => (
                <div key={i} className="pl-3 border-l-2 border-blue-300">
                  <p className="font-semibold text-sm text-slate-800">{item.sub}</p>
                  <p className="text-sm text-slate-600 mt-0.5">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function ManualPage() {
  const navigate = useNavigate();
  return (
    <div className="max-w-4xl mx-auto py-8 px-4" data-testid="manual-page">
      <div className="flex items-center gap-3 mb-2">
        <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
          <ArrowLeft className="w-4 h-4 mr-1" />Indietro
        </Button>
      </div>
      <div className="flex items-center gap-3 mb-6">
        <BookOpen className="w-8 h-8 text-blue-600" />
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Istruzione Operativa</h1>
          <p className="text-sm text-slate-500">Manuale d'uso Internal ERP - v1.0</p>
        </div>
      </div>
      <div className="space-y-1">
        {SECTIONS.map(s => <Section key={s.id} section={s} />)}
      </div>
      <p className="text-center text-xs text-slate-400 mt-8">Documento generato automaticamente - Internal ERP v1.0</p>
    </div>
  );
}
